import { useState } from 'react';
import { MailWarning, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../lib/api';
import { formatApiError } from '../../lib/errors';
import { Button } from '../ui/button';

export const VerifyEmailBanner = () => {
  const { user, token, refreshMe, isImpersonating } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified !== false || isImpersonating) return null;

  const resend = async () => {
    setBusy(true);
    try {
      const r = await api.resendVerification(token);
      if (r.data.already_verified) await refreshMe();
      else toast.success(`Confirmation link sent to ${user.email}`);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-6 flex flex-col sm:flex-row sm:items-center gap-3 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-3"
      data-testid="verify-email-banner">
      <MailWarning className="w-5 h-5 text-amber-300 shrink-0" />
      <p className="text-sm text-amber-100 flex-1">
        Confirm your email (<span className="font-medium break-all">{user.email}</span>) to unlock going Live. Check your inbox for the link.
      </p>
      <Button size="sm" variant="outline" disabled={busy} onClick={resend}
        className="border-amber-500/40 text-amber-200 hover:bg-amber-500/20 bg-transparent" data-testid="resend-verification-btn">
        {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Resend link
      </Button>
    </div>
  );
};
